import { HeaderNav } from './modules/hamburger.js';
import { MegaMenu } from './modules/megamenu.js';
import { SetPosition } from './modules/set-position.js';
import { Accordion } from './modules/accordion.js';
import { Slider } from './modules/slider.js';
import { Modal } from './modules/modal.js';
import { Parallax } from './modules/parallax.js';
import { ScrollArrow } from './modules/scroll-arrow.js';
import { BonbonMore } from './modules/bonbon-more.js';
import { CampaignMore, CampaignSlider } from './layout/campaign.js';
import { CouponMore } from './layout/coupon.js';
import { InformationScroll } from './layout/information.js';
import { TreatmentAccordion } from './layout/treatment.js';
import { ClinicTabs } from './clinic.js';
import { GallerySlider, GalleryLargeSlider } from './layout/gallery.js';
import { ExampleTabs } from './layout/example.js';
import { Calendar } from './layout/calendar.js';
import { SnsFloat } from './layout/sns.js';
import { FaqAccordion } from './layout/faq.js';
import { Form, FormMenuAccordion, FormTextareaAutoResize } from './layout/form.js';
import { TableListComparisonSync } from './layout/table.js';

document.addEventListener('DOMContentLoaded', () => {
  // ヘッダーナビゲーションの初期化
  new HeaderNav();
  // メガメニューの初期化
  new MegaMenu();
  // スクロール位置に応じたクラス追加の初期化
  new SetPosition();
  // アコーディオンの初期化
  new Accordion();
  // スライダーの初期化
  new Slider();
  // モーダルの初期化
  new Modal();
  // パララックスの初期化
  new Parallax();
  // スクロール矢印の初期化
  new ScrollArrow();
  // Bonbon もっと見るの初期化
  new BonbonMore();
  // Campaign もっと見るの初期化
  new CampaignMore();
  // Campaign Slider の初期化
  new CampaignSlider();
  // Coupon もっと見るの初期化
  new CouponMore();
  // Information スクロールの初期化
  new InformationScroll();
  // Treatment アコーディオンの初期化
  new TreatmentAccordion();
  // Clinic タブの初期化
  new ClinicTabs();
  // Example タブの初期化
  new ExampleTabs();
  // Gallery スライダーの初期化
  new GallerySlider();
  // Gallery Large スライダーの初期化
  new GalleryLargeSlider();

  document.querySelectorAll('.l-form-calendar').forEach((element) => {
    new Form(element);
  });
  new FormMenuAccordion();
  new FormTextareaAutoResize();

  // Calendar の初期化
  document.querySelectorAll('.l-calendar').forEach((element) => {
    new Calendar(element);
  });
  // SNS Float の初期化
  new SnsFloat();
  // FAQ Accordion の初期化
  new FaqAccordion();
  // Table List Comparison 高さ同期の初期化
  new TableListComparisonSync();
});
